import { FaLinkedin, FaGithub, FaWhatsapp } from "react-icons/fa";
import { SiGmail } from "react-icons/si";
import { trackEvent } from "../utils/analytics";

const Footer = () => {
  const handleSocialClick = (platform) => {
    trackEvent("external_click", {
      event_category: "Social",
      event_label: platform,
    });
  };

  return (
    <footer className="relative bg-gray-900 dark:bg-slate-950 text-white text-center py-10 mt-16 pb-28 transition-colors duration-300">
      {/* Social media icons with hover animation */}
      <ul className="flex justify-center gap-6 mb-4">
        <li>
          <a
            href="https://www.linkedin.com/in/munjwok-james-alala-4b5416327/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handleSocialClick("LinkedIn")}
            className="group relative flex h-14 w-14 items-center justify-center rounded-full border-2 border-white dark:border-slate-300 bg-white dark:bg-slate-200 text-gray-900 dark:text-slate-900 overflow-hidden transition-all"
          >
            <span className="relative z-10 text-2xl transition-transform duration-500 group-hover:rotate-[360deg] group-hover:text-white">
              <FaLinkedin />
            </span>
            <span className="absolute inset-0 top-full bg-[#0077b5] transition-all duration-500 group-hover:top-0" />
          </a>
        </li>

        <li>
          <a
            href="https://github.com/munji74"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handleSocialClick("GitHub")}
            className="group relative flex h-14 w-14 items-center justify-center rounded-full border-2 border-white dark:border-slate-300 bg-white dark:bg-slate-200 text-gray-900 dark:text-slate-900 overflow-hidden transition-all"
          >
            <span className="relative z-10 text-2xl transition-transform duration-500 group-hover:rotate-[360deg] group-hover:text-white">
              <FaGithub />
            </span>
            <span className="absolute inset-0 top-full bg-gray-800 dark:bg-slate-950 transition-all duration-500 group-hover:top-0" />
          </a>
        </li>

        <li>
          <a
            href="https://wa.me/256753257102"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handleSocialClick("WhatsApp")}
            className="group relative flex h-14 w-14 items-center justify-center rounded-full border-2 border-white dark:border-slate-300 bg-white dark:bg-slate-200 text-gray-900 dark:text-slate-900 overflow-hidden transition-all"
          >
            <span className="relative z-10 text-2xl transition-transform duration-500 group-hover:rotate-[360deg] group-hover:text-white">
              <FaWhatsapp />
            </span>
            <span className="absolute inset-0 top-full bg-green-500 transition-all duration-500 group-hover:top-0" />
          </a>
        </li>

        <li>
          <a
            href="mailto:munjijames02@gmail.com"
            onClick={() => handleSocialClick("Gmail")}
            className="group relative flex h-14 w-14 items-center justify-center rounded-full border-2 border-white dark:border-slate-300 bg-white dark:bg-slate-200 text-gray-900 dark:text-slate-900 overflow-hidden transition-all"
          >
            <span className="relative z-10 text-2xl transition-transform duration-500 group-hover:rotate-[360deg] group-hover:text-white">
              <SiGmail />
            </span>
            <span className="absolute inset-0 top-full bg-[#EA4335] transition-all duration-500 group-hover:top-0" />
          </a>
        </li>
      </ul>

      <p className="text-sm text-gray-400 dark:text-slate-400">
        © {new Date().getFullYear()} Munyijwok James Alala. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
